import React from "react";
import PassTemplate from "../Modals/PassTemplate";
import { useTranslation } from "react-i18next";
import { HiTrash, HiPlus, HiLink } from "react-icons/hi2";

interface LinksFormProps {
  activeTab: string;
  passTemplate: PassTemplate | null;
  newLinkName: string;
  newLinkUrl: string;
  setNewLinkName: (value: string) => void;
  setNewLinkUrl: (value: string) => void;
  addLink: (name: string, url: string) => void;
  removeLink: (index: number) => void;
  UpdateLinks: () => void;
}

const LinksForm: React.FC<LinksFormProps> = ({
  activeTab, passTemplate, newLinkName, newLinkUrl,
  setNewLinkName, setNewLinkUrl, addLink, removeLink, UpdateLinks,
}) => {
  const { t } = useTranslation();
  const inputClass = "w-full px-4 py-2.5 rounded-xl border border-gray-200 bg-gray-50 text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-400 focus:border-transparent transition";

  return (
    <div className={activeTab === "links" ? "block space-y-4 pt-4" : "hidden"}>

      {/* Existing links */}
      {passTemplate?.links && passTemplate.links.length > 0 && (
        <div className="bg-gray-50 rounded-2xl border border-gray-200 divide-y divide-gray-200 overflow-hidden">
          {passTemplate.links.map((link, index) => (
            <div key={link.id || index} className="flex items-center gap-3 px-4 py-3">
              <div className="w-8 h-8 rounded-lg bg-brand-50 flex items-center justify-center flex-shrink-0">
                <HiLink className="w-4 h-4 text-brand-500" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-gray-800 truncate">{link.name}</p>
                <p className="text-xs text-gray-400 truncate">{link.url}</p>
              </div>
              <button
                type="button"
                onClick={() => removeLink(index)}
                className="flex-shrink-0 p-1.5 rounded-lg text-gray-400 hover:bg-red-50 hover:text-red-500 transition"
              >
                <HiTrash className="w-4 h-4" />
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Add new link */}
      <div className="bg-gray-50 rounded-2xl border border-gray-200 p-4 space-y-3">
        <p className="text-sm font-semibold text-gray-700">{t("Add Link")}</p>
        <input
          type="text"
          value={newLinkName}
          onChange={e => setNewLinkName(e.target.value)}
          placeholder={t("name")}
          className={inputClass}
        />
        <input
          type="url"
          value={newLinkUrl}
          onChange={e => setNewLinkUrl(e.target.value)}
          placeholder="https://..."
          className={inputClass}
        />
        <button
          type="button"
          onClick={() => addLink(newLinkName, newLinkUrl)}
          disabled={!newLinkName.trim() || !newLinkUrl.trim()}
          className="w-full py-2.5 rounded-xl border-2 border-dashed border-brand-300 text-brand-600 text-sm font-semibold flex items-center justify-center gap-2 hover:bg-brand-50 disabled:opacity-40 disabled:cursor-not-allowed transition"
        >
          <HiPlus className="w-4 h-4" />{t("Add Link")}
        </button>
      </div>

      <button
        type="button"
        onClick={UpdateLinks}
        className="w-full py-3 rounded-xl bg-brand-600 text-white text-sm font-bold hover:bg-brand-700 transition active:scale-95"
      >
        {t("Next")}
      </button>
    </div>
  );
};

export default LinksForm;
